import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import { usePushAnonymousGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event';
import { CustomGtmEvent } from '@upright/ui/common/generic/components/google-tag-manager/use-push-gtm-event/payloads';
import Spinner from '@upright/ui/common/generic/components/progress/spinners/spinner';
import { FormModalBottomBar } from '@upright/ui/common/generic/modals/form-modal/form-modal-parts';
import { useSubscriptionContext } from './context';
import { BackLink } from './subscribe-page/shared/back-link';

export const SubscriptionModalBottomBar = (props: { hideBackLink?: boolean }) => {
  const context = useSubscriptionContext();
  const pushGtmEvent = usePushAnonymousGtmEvent();
  const [, setSubmitButtonClicked] = context.submitButtonClicked;

  return (
    <FormModalBottomBar>
      {/* "Change plan" is the left-hand item of this right-aligned action row, so it comes first in the
          DOM as well as on screen, and takes the free space in its own styles. Below tablet it is
          hidden, so being first costs the stacked layout nothing. See `back-link.tsx`. */}
      {!props.hideBackLink && <BackLink />}
      <section id="submit">
        <div id="buttonWrap">
          {!context.submitQuery.isPending ? (
            <button
              disabled={!context.canSubmit}
              onClick={() => {
                setSubmitButtonClicked(true);
                pushGtmEvent({ event: CustomGtmEvent.UA_BOOK_COMPANY_DEMO_SUBMIT, data: { tier: context.tier } });
                if (context.canSubmit) {
                  context.submit();
                }
              }}
              id={E2eTestElementId.SELF_SIGNUP_SUBMIT}
            >
              Submit
            </button>
          ) : (
            <Spinner size={'2em'} />
          )}
        </div>
      </section>
    </FormModalBottomBar>
  );
};
